import * as React from 'react';
import { Button } from 'styleguide-react';
import { t } from '../helper/locale';
import { ButtonStatus } from '../types/onboarding';

export const ActionButton: React.FunctionComponent<{
  url: string;
  buttonStatus: ButtonStatus;
  clickHandler: React.MouseEventHandler<HTMLAnchorElement>;
}> = ({ url, buttonStatus, clickHandler }) => {
  return (
    <div className="ActionButton">
      <a href={url} onClick={clickHandler} target="_blank" rel="noreferrer">
        <Button
          testId="action-button"
          className="ActionButton__button rck-btn"
          disabled={[ButtonStatus.LOADING, ButtonStatus.SUCCESS].includes(
            buttonStatus
          )}
          loading={buttonStatus === ButtonStatus.LOADING}
        >
          {buttonStatus === ButtonStatus.SUCCESS
            ? t('Connected')
            : t('Connect now')}
        </Button>
      </a>
    </div>
  );
};
